const SET_PROPERTY = 'SET_PROPERTY_VIDEOS_PAGE';

const SET_LOADING_VIDEOS = 'SET_LOADING_VIDEOS_VIDEOS_PAGE';
const UPDATE_VIDEOS = 'UPDATE_VIDEOS_VIDEOS_PAGE';
const SET_APPENDING_VIDEOS = 'SET_APPENDING_VIDEOS_VIDEOS_PAGE';
const APPEND_VIDEOS = 'APPEND_VIDEOS_VIDEOS_PAGE';
const SET_SHOW_MORE_VIDEOS = 'SET_SHOW_MORE_VIDEOS_VIDEOS_PAGE';
const SET_SEARCHING_VIDEOS = 'SET_SEARCHING_VIDEOS_VIDEOS_PAGE';
const SET_SEARCH_PHRASE = 'SET_SEARCH_PHRASE_VIDEOS_PAGE';

const SET_VIDEOS_FRESH = 'SET_VIDEOS_FRESH_VIDEOS_PAGE';
const REMOVE_VIDEO_ITEM = 'REMOVE_VIDEO_ITEM_VIDEOS_PAGE';
const REMOVE_VIDEO_EXPORT = 'REMOVE_VIDEO_EXPORT_VIDEOS_PAGE';
const UPDATE_EXPORT_PROGRESS = 'UPDATE_EXPORT_PROGRESS_VIDEOS_PAGE';
const SET_EXPORT_STATUS = 'SET_EXPORT_STATUS_VIDEOS_PAGE';

export default {
    SET_PROPERTY,
    SET_LOADING_VIDEOS,
    UPDATE_VIDEOS,
    SET_APPENDING_VIDEOS,
    APPEND_VIDEOS,
    SET_SHOW_MORE_VIDEOS,
    SET_SEARCHING_VIDEOS,
    SET_SEARCH_PHRASE,
    SET_VIDEOS_FRESH,
    REMOVE_VIDEO_ITEM,
    REMOVE_VIDEO_EXPORT,
    UPDATE_EXPORT_PROGRESS,
    SET_EXPORT_STATUS
}